export default __webpack_public_path__ + "static/media/Gegevens.a0445595.svg";